// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal customization */
.shop-catalog-modal .modal-content {
  border-radius: 10px;
  max-height: 85vh;
}

.shop-catalog-modal-body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

/* Grid layout - matches ShopByCategories */
.category-card-grid-modal {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 26px;
}

/* Category card styling - matches ShopByCategories exactly */
.category-card-modal {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 30px 28px;
  min-height: 110px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  width: 100%;
  transition: all 0.3s ease;
}

.category-card-modal:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.15);
}

.category-card-modal img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  flex-shrink: 0;
}

.category-card-modal span {
  font-size: 16.5px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

/* Responsive breakpoints */
@media (max-width: 1200px) {
  .category-card-grid-modal {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }

  .category-card-modal {
    padding: 24px 20px;
    gap: 16px;
  }

  .category-card-modal img {
    width: 56px;
    height: 56px;
  }

  .category-card-modal span {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .shop-catalog-modal-body {
    padding: 16px;
  }

  .category-card-grid-modal {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .category-card-modal {
    padding: 20px 16px;
    min-height: 90px;
  }

  .category-card-modal img {
    width: 48px;
    height: 48px;
  }

  .category-card-modal span {
    font-size: 14.5px;
  }
}

/* Custom scrollbar for modal body */
.shop-catalog-modal-body::-webkit-scrollbar {
  width: 8px;
}

.shop-catalog-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.shop-catalog-modal-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.shop-catalog-modal-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/supplier_app/MaterialCatalogShopwies/ShopCatalogModal.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,WAAW;EACX,4DAA4D;EAC5D,SAAS;AACX;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oCAAoC;AACpC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Modal customization */\n.shop-catalog-modal .modal-content {\n  border-radius: 10px;\n  max-height: 85vh;\n}\n\n.shop-catalog-modal-body {\n  padding: 24px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n/* Grid layout - matches ShopByCategories */\n.category-card-grid-modal {\n  display: grid;\n  width: 100%;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 26px;\n}\n\n/* Category card styling - matches ShopByCategories exactly */\n.category-card-modal {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 30px 28px;\n  min-height: 110px;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 10px;\n  width: 100%;\n  transition: all 0.3s ease;\n}\n\n.category-card-modal:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.15);\n}\n\n.category-card-modal img {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.category-card-modal span {\n  font-size: 16.5px;\n  font-weight: 600;\n  color: #333;\n  line-height: 1.4;\n}\n\n/* Responsive breakpoints */\n@media (max-width: 1200px) {\n  .category-card-grid-modal {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 20px;\n  }\n\n  .category-card-modal {\n    padding: 24px 20px;\n    gap: 16px;\n  }\n\n  .category-card-modal img {\n    width: 56px;\n    height: 56px;\n  }\n\n  .category-card-modal span {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .shop-catalog-modal-body {\n    padding: 16px;\n  }\n\n  .category-card-grid-modal {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .category-card-modal {\n    padding: 20px 16px;\n    min-height: 90px;\n  }\n\n  .category-card-modal img {\n    width: 48px;\n    height: 48px;\n  }\n\n  .category-card-modal span {\n    font-size: 14.5px;\n  }\n}\n\n/* Custom scrollbar for modal body */\n.shop-catalog-modal-body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.shop-catalog-modal-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.shop-catalog-modal-body::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.shop-catalog-modal-body::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
